import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import AssessmentLevelsContent from './AssessmentLevelsContent';
import AssessmentLevelsModal from '../modals/AssessmentLevelsModal';

const form = {
  keyword: '',
};

function AssessmentLevelsContainer({
  match,
  history,
  getList,
  dataList,
  isLoading,
  dataListPager,
  showData,
  removeData,
  ordinanceRevisionId,
  clearItem
}) {

  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <AssessmentLevelsModal dataInfo={data} type="EDIT" ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Update Assessment Level',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this assessment level?',
      () => {
        removeData(data.id, () => {
          getList({
            isPaginate: 1,
            ordinance_revision_id: ordinanceRevisionId
          });
          history.push(
            `/rpt/building/settings/assessment-levels/${_.get(dataList, '0.id')}`
          );
          showData(_.get(dataList, '0.id'), ordinanceRevisionId);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getList(
      {
        isPaginate: 1,
        ordinance_revision_id: ordinanceRevisionId,
      },
      (res) => {
        const id = _.get(res, 'data.0.id');
        if (id) {
          history.push(`/rpt/building/settings/assessment-levels/${id}`);
          showData(id, ordinanceRevisionId);
        } else clearItem(c.SHOW_DATA, {});
      }
    );
    return () => {
      setModal({ isOpen: false });
    };
  }, [ordinanceRevisionId]);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  
  useEffect(() => {
    if (debouncedSearchTerm) {
      getList({ isPaginate: 1, q: formData.keyword, ordinance_revision_id: ordinanceRevisionId });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:assessmentLevelId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Assessment Levels"
            getData={getList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:assessmentLevelId?`}
            listName="buildingKinds"
            label="Assessment Levels"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.classification')}
                </div>
              </div>
            )}
            noRightCard
            isLoading={isLoading}
            selected={params.assessmentLevelId}
            data={dataList}
            dataPager={dataListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:assessmentLevelId?`}
                    render={() => (
                      <AssessmentLevelsContent
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        ordinanceRevisionId={ordinanceRevisionId}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:assessmentLevelId?`}
                  render={() =>
                    !params.assessmentLevelId && dataList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(dataList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

AssessmentLevelsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  dataListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  removeData: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  clearItem: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_ASSESSMENT_LEVEL_LIST}.list`) || [],
  dataListPager: _.get(api, `${c.GET_ASSESSMENT_LEVEL_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_ASSESSMENT_LEVEL_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AssessmentLevelsContainer);
